import { Box } from "@mui/material";
import Footer from "../../components/Footer/Footer";
import "./FooterContainer.css";

function FooterContainer() {
	return (
		<Box className="footerContainer">
			<Footer />
		</Box>
	);
}

export default FooterContainer;
